import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import NavBar from './NavBar';
import TopBar from './TopBar';
import { Outlet } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

const PREFIX = 'DashboardLayout';

const classes = {
  root: `${PREFIX}-root`,
  wrapper: `${PREFIX}-wrapper`,
  contentContainer: `${PREFIX}-contentContainer`,
  content: `${PREFIX}-content`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`&.${classes.root}`]: {
    display: 'flex',
    overflow: 'hidden',
    width: '100%',
    minHeight: '100%',
  },

  [`& .${classes.wrapper}`]: {
    display: 'flex',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256,
    },
  },

  [`& .${classes.contentContainer}`]: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
  },

  [`& .${classes.content}`]: {
    display: 'flex',
    flex: '1 1 auto',
    height: '100%',
    overflow: 'hidden',
  }
}));

const DashboardLayout = ({ children }) => {

  const [isMobileNavOpen, setMobileNavOpen] = useState(false);
  const { pathname } = useLocation();

  return (
    <Root
      className={classes.root}
      style={{
        padding: pathname.includes('/app/application/tickets') ? '0px' : '96px 0',
      }}
    >
      <TopBar onMobileNavOpen={() => setMobileNavOpen(true)} />
      <NavBar onMobileClose={() => setMobileNavOpen(false)} openMobile={isMobileNavOpen} />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
      <Outlet />
    </Root>
  );
};

DashboardLayout.propTypes = {
  children: PropTypes.node,
};

export default DashboardLayout;
